import EachFibLevels, {
  fibLevelsPropTypes,
  fibLevelsDefaultProps,
} from "./EachFibLevels";

// Config sobre EachFibLevels (auditoria 2026-07-17, item 1c)
class EachFibExtension extends EachFibLevels {}

EachFibExtension.defaultLevels = [
  { level: 0, display: true },
  { level: 61.8, display: true },
  { level: 100, display: true },
  { level: 127.2, display: true },
  { level: 161.8, display: true },
  { level: 261.8, display: true },
  { level: 423.6, display: true },
];
// Extension: níveis projetados a partir do ponto inicial (y1)
EachFibExtension.computeLevelY = ({ level, y1, dy }) => y1 + (level / 100) * dy;
EachFibExtension.percentDigits = 1;

EachFibExtension.propTypes = fibLevelsPropTypes;
EachFibExtension.defaultProps = fibLevelsDefaultProps;

export default EachFibExtension;
